import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constanst } from 'src/app/core/constants/constans.component';

@Component({
  selector: 'app-detalle-proveedores',
  templateUrl: './detalle-proveedores.component.html',
  styleUrls: ['./detalle-proveedores.component.css']
})
export class DetalleProveedoresComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  razonSocial = this.data.provider.value.razonSocial;
  proveedorForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogDetalleProveedorRef: MatDialogRef<DetalleProveedoresComponent>
  ) { }

  ngOnInit(): void {
    this.proveedorForm = new FormGroup ({
      // idProveedor: new FormControl(this.data.row.proveedor.idProveedor),
      referencia: new FormControl({value: this.data.provider.value.referencia, disabled: true}),
      razonSocial: new FormControl({value: this.data.provider.value.razonSocial, disabled: true}),
      contacto: new FormControl({value: this.data.provider.value.contacto, disabled: true}),
      actividad: new FormControl({value: this.data.provider.value.actividad, disabled: true}),
      especialidad: new FormControl({value: this.data.provider.value.especialidad, disabled: true}),
      direccion1: new FormControl({value: this.data.provider.value.direccion1, disabled: true}),
      direccion2: new FormControl({value: this.data.provider.value.direccion2, disabled: true}),
      telefono: new FormControl({value: this.data.provider.value.telefono, disabled: true}),
      fax: new FormControl({value: this.data.provider.value.fax, disabled: true}),
      email: new FormControl({value: this.data.provider.value.email, disabled: true}),
      web: new FormControl({value: this.data.provider.value.web, disabled: true}),
      comentario: new FormControl({value: this.data.provider.value.comentario, disabled: true}),
    })
  }

  closeDialogDetalleProveedor() {
    this.dialogDetalleProveedorRef.close();
  }

}
